module.exports = __webpack_public_path__ + "img/center front length to waist.4bed235d.png";